

import React from "react";
import { MdOutlineFileDownload } from "react-icons/md";
// import image_png from "../images/image.png";
import { CIcon } from "@coreui/icons-react";
import { cilEducation } from "@coreui/icons";
import { useEffect, useRef, useState } from "react";

const useFadeInOnScroll = () => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 } // mobile ke liye perfect
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  return [ref, visible];
};


const Resume = () => {
  
 const [containerRef, isVisible] = useFadeInOnScroll();
  
  const educationInfo = [
    {
      degree: "Master Of Computer Applications",
      institution: "Maulana Azid National Institute of Technology, Bhopal",
      duration: "July 2024 - Jun 2027",
      description:
        "Specialized in software engineering with practical experience in system design and distributed systems.",
    },
    {
      degree: "BCA (Bachler of Computer Application)",
      institution: "Arhiant Collage, Indore",
      duration: "Aug 2021 – Jun 2024",
      description:
        "Built a strong foundation in programming, databases, and web technologies through hands-on projects.",
    },
  ];

  const resumeUrl = "https://docs.google.com/document/d/1TF7yBxzo02PUQ3-ajJfI8O5b7JZS-mla/export?format=pdf";



  const mySkills = [
    { name: "Java", percentage: 80 },
    { name: "Data Structure", percentage: 70 },
    { name: "Algorithms", percentage: 75 },
    { name: "System Design", percentage: 75 },
    { name: "API Development", percentage: 70 },
    { name: "Web Technology", percentage: 60 },
    { name: "Microservices", percentage: 50 },
    { name: "Amazon AWS", percentage: 60 },
    { name: "Git / GitHub", percentage: 70 },
  ];

  return (
    // <div className="text-gray-200 min-h-screen  font-sans mb-10 md:mb-0">
    <div
  ref={containerRef}
  className={`text-gray-200 min-h-screen font-sans mb-10 md:mb-0
    opacity-0 ${isVisible ? "blur-zoom-in" : ""}
  `}
>

      {/* Heading */}
      <h1 className="text-[28px] sm:text-[38px] md:text-[45px] font-semibold mt-[-25px] sm:mt-[-60px] md:mt-[-70px]">
        Career Snapshot
      </h1>

      <hr className="h-[4px] sm:h-[5px] bg-cyan-300 border-0 mt-3 w-[80px] sm:w-[100px]" />

      {/* Resume Download */}
      <div className="flex justify-center mt-8">
        <a
          href={resumeUrl}
          download
          className="relative inline-flex items-center space-x-3 px-6 sm:px-8 py-3 font-semibold text-white bg-gray-950 rounded-full overflow-hidden shadow-lg transform transition-all duration-300 hover:scale-110 hover:bg-gray-700 border border-gray-500"
        >
          <MdOutlineFileDownload size={20} className="relative z-10" />
          <span className="relative z-10 text-xs sm:text-base">Download Resume</span>
          <span className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-white/0 via-white/40 to-white/0 opacity-70 animate-shine pointer-events-none rounded-full"></span>
        </a>
      </div>

      {/* --- Education Section --- */}
      <div className="mt-12 relative  sm:ml-4">

        {/* Vertical Line Adjusted for mobile */}
        <div className="absolute left-[1rem] sm:left-[1.4rem] top-[3rem] bottom-[10rem] w-[2px] bg-gray-600"></div>

        {/* Heading Row */}
        <div className="flex items-center space-x-2 sm:space-x-4 mb-10">
          <div className="h-[45px] w-[45px] sm:h-[50px] sm:w-[50px] border-t border-l border-gray-600 flex items-center justify-center rounded-xl">
            <CIcon icon={cilEducation} className="h-[22px] w-[22px] sm:h-[25px] sm:w-[25px] text-[#00b5fc]" />
          </div>
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-50">Education</h2>
        </div>

        {/* Timeline Items */}
        {educationInfo.map((edu, index) => (
          <div key={index} className="relative mb-12">
            
            {/* Dot */}
            <div className="absolute left-[0.7rem] sm:left-[0.9rem] top-1 h-3 w-3 sm:h-4 sm:w-4 rounded-full bg-blue-300 border-4 border-gray-700"></div>

            {/* Content */}
            <div className="ml-[45px] sm:ml-[50px]">
              <h3 className="text-xl sm:text-3xl font-semibold text-gray-100">{edu.degree}</h3>
              <p className="text-base sm:text-2xl text-gray-400 mt-1">{edu.institution}</p>
              <p className="text-md sm:text-lg text-cyan-400 mt-4">{edu.duration}</p>
              <p className="text-sm sm:text-lg text-gray-300 mt-2 max-w-xl">{edu.description}</p>
            </div>
          </div>
        ))}
      </div>

      {/* --- Skills Section --- */}
      <div className="mt-10">
        <div className="flex items-center space-x-3 sm:space-x-4 mb-6">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-50">My Skills</h2>
        </div>

        <div className="border p-2 sm:p-8 border-gray-700 rounded-2xl space-y-4">
          {mySkills.map((skill, index) => (
            <div key={index}>
              <div className="flex justify-between items-center mb-2">
                <span className="text-md sm:text-lg text-gray-100">{skill.name}</span>
                <span className="text-md sm:text-lg text-gray-300">{skill.percentage}%</span>
              </div>

              {/* Progress Bar */}
              <div className="w-full bg-gray-700 rounded-full h-2 sm:h-3 relative overflow-hidden">
                <div
                  className="h-full rounded-full bg-blue-500 relative overflow-hidden"
                  style={{
                    width: `${skill.percentage}%`,
                    transition: "width 1.5s ease-in-out",
                  }}
                >
                  <div className="absolute top-0 left-0 h-full w-10 bg-gradient-to-r from-white/70 via-white/20 to-transparent rounded-full animate-sheen"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
};

export default Resume;

